import axios from "axios";
import { ENV } from "../config/clientConfig";

const { api } = ENV;

// Store user data by userId to avoid duplicates
const userDataCache = new Map();

export const searchInteractions = (interval, pageNumber) => {
  return axios
    .post(
      `${api}/api/interactions/screenRecordings`,
      {
        interval: interval,
        pageNumber: pageNumber
      },
      { headers: { "Content-Type": "application/json" } }
    )
    .then((res) => {
        console.log('searchInteractions Response:', res.data);
        const conversationsData = res.data;
        return conversationsData;
    })
    .catch((error) => {
      console.error('API Error:', error);
      if (error.response) {
        console.error('Error Response:', error.response.data);
      }
      return [];
    });
};

export const expandConversationUser = (userId, conversationsData) => {
  return axios
    .get(`${api}/api/user/${userId}`)
    .then((res) => {
      const userData = res.data;
      
      // Store user data in cache to avoid duplicate API calls
      userDataCache.set(userId, userData);
      
      // Update all conversations that have this userId
      conversationsData.forEach((conversation) => {
        conversation.participants.forEach((participant) => {
          if (participant.userId === userId) {
            participant.userDetails = userData;
          }
        });
      });
      
      return userData;
    })
    .catch((error) => {
      console.error(`Error fetching user ${userId}:`, error);
    });
};

export const getUserFromCache = (userId) => {
  return userDataCache.get(userId);
};

export const clearUserCache = () => {
  userDataCache.clear();
};